// extracted by mini-css-extract-plugin
export var colorSquare = "_t9-0";
export var danger = "_t9-5";
export var lightPink = "_t9-8";
export var neutralBlue = "_t9-7";
export var neutralYellow = "_t9-6";
export var normal = "_t9-1";
export var primary = "_t9-2";
export var primaryLight = "_t9-3";
export var solidBlack = "_t9-g";
export var solidGreen = "_t9-b";
export var solidLightBlue = "_t9-d";
export var solidNavy = "_t9-c";
export var solidOrange = "_t9-f";
export var solidPink = "_t9-e";
export var solidRed = "_t9-9";
export var solidYellow = "_t9-a";
export var success = "_t9-4";